module.exports = __webpack_public_path__ + "img/Bonus-Komisi-Icon-Collapse.fa73f0d8.svg";